import React from 'react'
import './ContactForm.scss'
import Information from './Components/Information'
import Contactos from './Components/Contactos'

interface IContactFormProps {
  buttonClose: () => void
}


const ContactForm: React.FC<IContactFormProps> = ({buttonClose}) => {
  return (
    <div className='contact-form-container'>
        <Contactos buttonClose={buttonClose}/>
        <Information buttonClose= {buttonClose}/>
    </div>
  )
}

export default ContactForm
